import React from 'react';
import PropTypes from 'prop-types';
import makeConnectTo from '../../../util/makeConnectTo';
import api from '../../../../Api';

const CatalogFoldersContext = React.createContext();

const name = 'catalogFoldersDataStore';

export const useCatalogFolders = () => React.useContext(CatalogFoldersContext);

export const connectToCatalogFolders = makeConnectTo(
	CatalogFoldersContext,
	name,
);

export default class CatalogFoldersDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		isLoading: true,
		catalogFoldersData: {},
	};

	render() {
		const catalogFoldersDataStore = this.getStore();
		return (
			<CatalogFoldersContext.Provider value={catalogFoldersDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(catalogFoldersDataStore)
					: this.props.children}
			</CatalogFoldersContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchCatalogFolders();
	}

	componentWillUnmount() {
		if (
			this.catalogFoldersFetch &&
			typeof this.catalogFoldersFetch.cancel === 'function'
		) {
			this.catalogFoldersFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		isLoading: () => state.isLoading,
		refresh: () => this.refreshCatalogFolders(),
		saveCatalogFolders: (catalogId, commaSeparatedFolders) =>
			this.saveCatalogFolders(catalogId, commaSeparatedFolders),
	});

	refreshCatalogFolders = () => {
		return this.fetchCatalogFolders();
	};

	fetchCatalogFolders = () => {
		const request = api.cancelableGet(`/api/v1/catalogs/folders`);
		request.promise.then(this.cacheApiResponse);
		this.catalogFoldersFetch = request;
		return this.catalogFoldersFetch.promise;
	};

	cacheApiResponse = apiResponse => {
		this.setState({
			isLoading: false,
			catalogFoldersData: this.createTreeObject(apiResponse),
		});
	};

	createTreeObject = res => {
		var tree = [];
		var folderMap = [];

		Object.keys(res.catalogIdsByFolder).forEach((folder, idx) => {
			var primaryNode = {};
			primaryNode.title = folder;
			primaryNode.key = 'pn-' + idx;
			var children = [];
			res.catalogIdsByFolder[folder].forEach(catalogId => {
				const catalog = res.catalogs.filter(
					c => c.catalogID === catalogId,
				);
				var childNode = {};
				childNode.title =
					catalog.length > 0 ? catalog[0].name : 'Catalog Removed';
				childNode.key = catalog.length > 0 ? catalogId : -1;
				children.push(childNode);

				if (catalog.length > 0) {
					folderMap.push({
						folder: folder,
						catalogId: catalogId,
					});
				}
			});
			primaryNode.children = children;
			tree.push(primaryNode);
		});

		var catalogFoldersData = {};
		catalogFoldersData.tree = tree;
		catalogFoldersData.folderMap = folderMap;
		return catalogFoldersData;
	};

	saveCatalogFolders = (catalogId, folders) => {
		return api
			.put(`/api/v1/catalogs/${catalogId}/folders`, folders)
			.then(() => {
				this.refreshCatalogFolders();
			});
	};
}
